<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>schedule</mat-icon> Stunden erfassen
</h2>

<mat-dialog-content class="st-content">
  <div class="st-context sk-muted" *ngIf="data.einsatzLabel">
    <mat-icon class="sk-inline-icon">event</mat-icon> {{ data.einsatzLabel }}
  </div>

  <div class="st-offline-hint" *ngIf="isOffline">
    <mat-icon>cloud_off</mat-icon>
    <span>Offline – neue Stunden werden gespeichert und nachgesendet. Bereits gebuchte
      Stunden sind erst nach der Synchronisation sicht- und änderbar.</span>
  </div>

  <mat-form-field appearance="outline" class="date-field">
    <mat-label>Datum</mat-label>
    <input matInput type="date" [(ngModel)]="workDate" (change)="onDateChange()" required>
  </mat-form-field>

  <div class="st-loading" *ngIf="loading">
    <mat-spinner diameter="24"></mat-spinner> <span class="sk-muted">Buchungen laden…</span>
  </div>

  <div class="section-label">
    <mat-icon class="sk-inline-icon">groups</mat-icon> Personen &amp; Stunden
  </div>

  <p class="sk-muted st-empty-hint" *ngIf="rows.length === 0">
    Noch keine Personen. Füge unten die eingeteilte Kolonne oder weitere Mitarbeiter hinzu.
  </p>

  <div class="person-row" *ngFor="let row of rows" [class.booked]="row.entryId != null">
    <div class="person-info">
      <span class="person-name">{{ row.label }}</span>
      <span class="person-tags">
        <span class="tag planned" *ngIf="row.planned">geplant</span>
        <span class="tag booked" *ngIf="row.entryId != null && (!row.status || row.status === 'Submitted')">gebucht</span>
        <span class="tag approved" *ngIf="row.status === 'Approved'">
          <mat-icon class="tag-icon">lock</mat-icon>freigegeben
        </span>
        <span class="tag locked" *ngIf="row.status === 'Locked'">
          <mat-icon class="tag-icon">lock</mat-icon>abgerechnet
        </span>
      </span>
    </div>
    <mat-form-field appearance="outline" class="hours-field">
      <mat-label>Std.</mat-label>
      <input matInput type="number" min="0" step="0.25" [(ngModel)]="row.hours" [disabled]="isRowLocked(row)">
      <span matSuffix>h</span>
    </mat-form-field>
    <button mat-icon-button class="row-remove" (click)="removeRow(row)"
            matTooltip="{{ row.entryId != null ? 'Buchung entfernen' : 'Zeile entfernen' }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="quick-presets" *ngIf="rows.length > 0">
    <span class="sk-muted">Gesamt: <strong>{{ totalHours }} h</strong></span>
  </div>

  <div class="section-label add-label">
    <mat-icon class="sk-inline-icon">person_add</mat-icon> Person hinzufügen
  </div>

  <div class="add-row">
    <mat-form-field appearance="outline" class="add-select">
      <mat-label>Aus Team / Arbeiter wählen</mat-label>
      <mat-select [(ngModel)]="addKey">
        <mat-option *ngFor="let p of availableRoster" [value]="(p.workerId != null ? 'w:' + p.workerId : (p.personUserId ? 'u:' + p.personUserId : 'n:' + p.label))">
          {{ p.label }}
        </mat-option>
        <mat-option [value]="freeKey">Andere Person …</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="add-free" *ngIf="addKey === freeKey">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="freeName" placeholder="Vor- und Nachname">
    </mat-form-field>
    <button mat-stroked-button class="add-btn" (click)="addFromRoster()"
            [disabled]="!addKey || (addKey === freeKey && !freeName.trim())">
      <mat-icon>add</mat-icon> Hinzufügen
    </button>
  </div>

  <p class="sk-muted free-hint" *ngIf="addKey === freeKey">
    <mat-icon class="sk-inline-icon">info</mat-icon>
    Neue Personen werden als Arbeiter (ohne Login) im Team gespeichert und sind danach auswählbar.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Schließen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
    <mat-icon *ngIf="!saving">check</mat-icon> Speichern
  </button>
</mat-dialog-actions>
